/* eslint-disable react/no-unstable-nested-components */
import React, { useRef, useState } from "react";
import CustomTable from "../../../Core/Components/CustomTable";
import ChevronIcon from "../../../Common/Svgs/ChevronIcon";
import { batteryDetailsColumns } from "../Data/BatteryDetailData";
import BatteryIcon from "../../../Common/Svgs/BatteryIcon";

const LOCAL_DEFAULT_LIMIT = 10;

const BatteryDetailTable = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const data = [];

  const tableRef = useRef(null);

  return (
    <div
      className={`h-[calc(100vh-544px)] ${data.length && "overflow-y-scroll"}`}
      ref={tableRef}
    >
      <CustomTable
        disableScroll
        columns={batteryDetailsColumns}
        data={data.length}
        emptyState={
          <BatteryIcon className="w-4 h-4 fill-none stroke-dark-grey-text" />
        }
        customTableClassName="w-full"
        pagination={{
          pageSize: LOCAL_DEFAULT_LIMIT,
          total: data.length,
          showSizeChanger: false,
          onChange: (page) => {
            setCurrentPage(page);
          },
          current: currentPage,
          itemRender: (current, type, originalElement) => {
            const lastPage = data.length / current;

            if (type === "prev" && current === 0) {
              return (
                <button
                  type="button"
                  className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                  style={{
                    pointerEvents: "none",
                  }}
                >
                  <ChevronIcon className="stroke-dark-gray" />
                </button>
              );
            }

            if (type === "prev" && current > 0) {
              return (
                <button
                  type="button"
                  className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                >
                  <ChevronIcon className="stroke-dark-gray" />
                </button>
              );
            }

            if (type === "next" && lastPage <= 10) {
              return (
                <button
                  type="button"
                  className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                  style={{ pointerEvents: "none" }}
                >
                  <ChevronIcon className="stroke-dark-gray" />
                </button>
              );
            }

            if (type === "next") {
              return (
                <button
                  type="button"
                  className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
                >
                  <ChevronIcon className="stroke-dark-gray" />
                </button>
              );
            }

            return originalElement;
          },
        }}
      />
    </div>
  );
};

export default BatteryDetailTable;
